export default __webpack_public_path__ + "static/media/i (20).3b0c0f11.jpg";